<template>
  <div class="plan">
    <liuxiaoshima :data="data.liuxiaoshima" v-if="data?.liuxiaoshima" />
    <qisierxiaoqiwusanma
      :data="data.qisierxiaoqiwusanma"
      v-if="data?.qisierxiaoqiwusanma"
    />
    <yixiaoyimadagongkai
      :data="data.yixiaoyimadagongkai"
      v-if="data?.yixiaoyimadagongkai"
    />
    <caishensongfushima
      :data="data.caishensongfushima"
      v-if="data?.caishensongfushima"
    />
    <yixiaoyimaliusanyixiao
      :data="data.yixiaoyimaliusanyixiao"
      v-if="data?.yixiaoyimaliusanyixiao"
    />
    <wenshashima :data="data.wenshashima" v-if="data?.wenshashima" />
    <jiayesixiao :data="data.jiayesixiao" v-if="data?.jiayesixiao" />
    <erboerma :data="data.erboerma" v-if="data?.erboerma" />
    <ertouerma :data="data.ertouerma" v-if="data?.ertouerma" />
    <shujinguangxuanjishi
      :data="data.shujinguangxuanjishi"
      v-if="data?.shujinguangxuanjishi"
    />
    <jueshasanxiao :data="data.jueshasanxiao" v-if="data?.jueshasanxiao" />
    <wuxiaoerqibizhong
      :data="data.wuxiaoerqibizhong"
      v-if="data?.wuxiaoerqibizhong"
    />
  </div>
</template>

<script setup>
import { myHttp } from "@/request/index.js";
import { ref } from "vue";
import yixiaoyimadagongkai from "./yixiaoyimadagongkai.vue";
import yixiaoyimaliusanyixiao from "./yixiaoyimaliusanyixiao.vue";
import caishensongfushima from "./caishensongfushima.vue";
import liuxiaoshima from "./liuxiaoshima.vue";
import shujinguangxuanjishi from "./shujinguangxuanjishi.vue";
import qisierxiaoqiwusanma from "./qisierxiaoqiwusanma.vue";
import ertouerma from "./ertouerma.vue";
import erboerma from "./erboerma.vue";
import jiayesixiao from "./jiayesixiao.vue";
import wenshashima from "./wenshashima.vue";
import jueshasanxiao from "./jueshasanxiao.vue";
import wuxiaoerqibizhong from "./wuxiaoerqibizhong.vue";

const data = ref(null);

function loadData() {
  myHttp.get("/api/information/queryAll_6").then((res) => {
    if (res.success) {
      data.value = res.data;
      console.log({ ...data.value }, "data");
    }
  });
}

loadData();
</script>

<style lang="scss" scoped>
::v-deep .plan_item {
  .plan_item_title {
    // background-color: #3ebc40 !important;
    background-image: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
  ul {
    li {
      // background: linear-gradient(to bottom, #e893f9, #ab79e4) !important;
      padding: 12px 0;
      font-weight: 600;
    }
  }
}
.plan {
  .title {
    text-align: center;
    // background-color: #009788;
    font-size: 25px;
    font-weight: bold;
    padding: 6px 0;
  }
  .plan_item {
    border: 1px solid #009788;
    .plan_item_advertisement {
      img {
        width: 100%;
        height: 40px;
        display: block;
      }
    }
    .plan_item_title {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      font-weight: bold;
      text-align: center;
      // background-image: linear-gradient(to bottom, #e893f9, #ab79e4) !important;
      padding: 3px 0;
      border-top: 2px solid #767474;
      border-bottom: 2px solid #767474;
      img {
        width: 30px;
        height: 30px;
      }
    }
    ul {
      background-color: #eee;
      li {
        text-align: center;
        padding: 5px 12px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        .value {
          color: red;
          .win {
            background-color: #ffff00;
          }
        }
        &:not(:last-child) {
          border-bottom: 2px solid #d2d2d2;
        }
      }
      .li_win {
        .winText {
          color: #d00880;
        }
      }
      .suck {
        text-decoration-line: line-through;
      }
    }
  }

  .TK118 {
    width: 100%;
    height: 70px;
  }
}
</style>